import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactModal from 'react-modal'
import Spinner from 'react-spinner'
import 'react-spinner/react-spinner.css'
import NotificationSystem from 'react-notification-system'

import { open, sendPassword, zoomIn, zoomOut, showNotification, hideInputMeta, setSignMeta, setTextMeta, setSoundMeta,setImageMeta } from '../actions'

import InputPassword from '../components/InputPassword'
import ImageButton from '../components/ImageButton'
import { parserParams, getDocUrl } from '../utils/params'
import MetaInput from '../components/MetaInput'

import './overlay.css'

class Overlay extends Component {
    componentDidMount() {
        let params = parserParams(this.props.params)

        this.props.open(getDocUrl(params))
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.noti !== nextProps.noti) {
            this._addNotification(nextProps.noti)
        }
    }

    visibleModal() {
        if (this.getModalContent() !== undefined) {
            return true
        }
        return false
    }

    getModalContent() {
        if (this.props.lockPassword) {
            return <InputPassword sendPassword={(pass) => this.sendPassword(pass)} checkPassword={this.props.checkPassword} />
        } else if (this.props.isShowInputMeta) {
            if (this.props.metaType === 'META_TEXT_INFO') {
                return <MetaInput index={this.props.metaIndex} metaType={this.props.metaType} sendData={this.props.setTextMeta} close={this.props.hideInputMeta} />
            } else if (this.props.metaType === 'META_CHECK_INFO') {
            } else if (this.props.metaType === 'META_RADIO_INFO') {
            } else if (this.props.metaType === 'META_RADIO_SUB_INFO') {
            } else if (this.props.metaType  === 'META_SIGNVECTOR_INFO') {
            } else if (this.props.metaType  === 'META_IMAGE_INFO') {
                return <MetaInput index={this.props.metaIndex} metaType={this.props.metaType} sendData={this.props.setImageMeta} close={this.props.hideInputMeta} />
            } else if (this.props.metaType === 'META_SIGN_INFO') {
                return <MetaInput index={this.props.metaIndex} metaType={this.props.metaType} sendData={this.props.setSignMeta} close={this.props.hideInputMeta} />
            } else if (this.props.metaType ==='META_VOICE_INFO') {
                return <MetaInput index={this.props.metaIndex} metaType={this.props.metaType} sendData={this.props.setSoundMeta} close={this.props.hideInputMeta} />
            }
        } 
        return
    }

    visibleProgress() {
        return this.props.showProgress
    }

    sendPassword(password) {
        this.props.sendPassword(password)
    }

    _addNotification(noti) {
        if (noti !== undefined && noti.level !== undefined) {
            this._notificationSystem.addNotification(noti)
        }
    }

    render_printArea() {
        if (this.props.showPrintArea) {
            return(<div className="printArea">
                <svg height="72" width="72">
                    <circle cx="36" cy="36" r="28" stroke-width="0" fill="grey" />
                </svg>
                <ImageButton normal={require("../image/baseline_print_white.png")} pressed={require("../image/baseline_print_black.png")} alt="print" onClick={() => window.print()} />
            </div>)
        }
    }

    render_zoomArea() {
      if (this.props.showZoomArea) {
            return(<div className="zoomArea">
                    <ImageButton normal={require("../image/zoomin_ico_n.png")} pressed={require("../image/zoomin_ico_p.png")} alt="zoom in" onClick={this.props.zoomIn} />
                    <ImageButton normal={require("../image/zoomout_ico_n.png")} pressed={require("../image/zoomout_ico_p.png")} alt="zoom out" onClick={this.props.zoomOut} />
                </div>)
       }
    }

    render() {
        return (
            <div className="overlay no-print">
                { this.render_printArea() }
                { this.render_zoomArea() }
                <NotificationSystem ref={(c) => this._notificationSystem = c} />
                <ReactModal isOpen={this.visibleModal()} className="Modal" contentLabel="Modal">
                    { this.getModalContent() }
                </ReactModal>
                <ReactModal isOpen={this.visibleProgress()} className="Modal" contentLabel="Progress">
                    <div className="ModalContent">
                        <Spinner />
                    </div>
                </ReactModal>
            </div>
        )
    }
}

Overlay.propTypes = {
    params: PropTypes.string.isRequired,
    showZoomArea: PropTypes.bool.isRequired,
}

function mapStateToProps(state) {
    const { extra, viewer } = state
    const { openStatus } = viewer

    return {
        noti: extra.notiData,
        showProgress: viewer.showProgress,
        showZoomArea: extra.userAgent.mobile() === null ? extra.showZoomArea : false,
        showPrintArea: extra.userAgent.mobile() === null ? extra.showPrintArea : false,
        fileStatus: viewer.fileStatus,
        lockPassword: openStatus.fileInfo ? openStatus.fileInfo.lockPassword : false,
        checkPassword: viewer.checkPassword,
        isShowInputMeta : extra.showInputMeta.isShow,
        metaIndex : extra.metaIndex,
        metaType : extra.metaType,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        open: (url) => dispatch(open(url)),
        sendPassword: (password) => dispatch(sendPassword(password)),
        zoomIn: () => dispatch(zoomIn()),
        zoomOut: () => dispatch(zoomOut()),
        showNotification: (noti) => dispatch(showNotification(noti)),
        hideInputMeta:() => dispatch(hideInputMeta()),
        setSignMeta:(index, sign) => dispatch(setSignMeta(index, sign)),
        setTextMeta:(index, text) => dispatch(setTextMeta(index, text)),
        setSoundMeta:(index, snd) => dispatch(setSoundMeta(index, snd)),
        setImageMeta:(index, image) => dispatch(setImageMeta(index, image)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Overlay)



// WEBPACK FOOTER //
// ./src/containers/overlay.js